import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const segmentedControlDefaultVariants = {
  "size": "md",
  "fullWidth": false
}
const segmentedControlCompoundVariants = []

const segmentedControlSlotNames = [
  [
    "root",
    "segmentedControl__root"
  ],
  [
    "thumb",
    "segmentedControl__thumb"
  ],
  [
    "item",
    "segmentedControl__item"
  ],
  [
    "icon",
    "segmentedControl__icon"
  ]
]
const segmentedControlSlotFns = /* @__PURE__ */ segmentedControlSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, segmentedControlDefaultVariants, getSlotCompoundVariant(segmentedControlCompoundVariants, slotName))])

const segmentedControlFn = memo((props = {}) => {
  return Object.fromEntries(segmentedControlSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const segmentedControlVariantKeys = [
  "size",
  "fullWidth"
]
const getVariantProps = (variants) => ({ ...segmentedControlDefaultVariants, ...compact(variants) })

export const segmentedControl = /* @__PURE__ */ Object.assign(segmentedControlFn, {
  __recipe__: false,
  __name__: 'segmentedControl',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: segmentedControlVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "fullWidth": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, segmentedControlVariantKeys)
  },
  getVariantProps
})